// extracted by mini-css-extract-plugin
module.exports = {"container":"Chip_container__2WO0y","clearIcon":"Chip_clearIcon__10m7I","clearable":"Chip_clearable__3Xhlm"};